





















import { Component, Vue } from 'vue-property-decorator';
import mixins from 'vue-class-component';
import { appModule } from '@/store/modules/ModuleApp';
import { permissionModule } from '@/store/modules/ModulePermission';
import { systemModule } from '@/store/modules/ModuleSystem';
import { settingsModule } from '@/store/modules/ModuleSettings';

import serviceCommon from '@/service/ServiceCommon';
import LibsModelSceneMixins from '@/libs/LibsModelSceneMixins';
import SidebarItem from './SidebarItem.vue';
import SidebarLogo from './SidebarLogo.vue';
import variables from '@/styles/_variables.scss';

@Component({
	name: 'SideBar',
	components: {
		SidebarItem,
		SidebarLogo
	}
})
/** docs */
export default class SideBar extends mixins(LibsModelSceneMixins) {
	/** document hooks */
	public get sidebar(): any {
		return appModule.sidebar;
	}

	/** document hooks */
	public get routes(): any {
		// console.log(' permissionModule.routes', permissionModule.routes);

		return permissionModule.routes;
	}

	/** document hooks */
	public get showLogo(): any {
		return false; // settingsModule.showSidebarLogo;
	}

	/** document hooks */
	public get menuActiveTextColor(): any {
		if (settingsModule.sidebarTextTheme) {
			return settingsModule.theme;
		}

		return variables.menuActiveText;
	}

	/** document hooks */
	public get variables(): any {
		return variables;
	}

	/** document hooks */
	public get activeMenu(): any {
		const route: any = this.$route;
		const { meta, path }: any = route;
		// if set path, the sidebar will highlight the path you set

		if (meta.activeMenu) {
			return meta.activeMenu;
		}

		return path;
	}

	/** document hooks */
	public get isCollapse(): any {
		return !this.sidebar.opened;
	}

	/** document hooks */
	private created(): void {
		// IEG场景 - 订单、需求待办状态刷新
		if (this.isSceneIEG()) {
			this.getApprovalOrderReceive();
		}
	}

	/** 获取订单、验收待办条数 */
	public async getApprovalOrderReceive(): Promise<void> {
		const res = await serviceCommon.queryWorkTableCount();
		if (res.status === 0 && res.data) {
			// 存储待办数据长度
			systemModule.setTodoList({
				...systemModule.todoList,
				purchaseorderApproval: Number(res.data.orderCount),
				'/receiveAccept/receiveAcceptApproval': Number(res.data.acceptCount)
			});
		}
	}
}
